import axios from '../axios'
import config from '../config'

export const generateLetterOfIntent = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/letter_of_intent`, {
    options
  })
}

export const generateWebNda = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/web_nda`, {
    options
  })
}

export const generateAmbassadorAgreement = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/ambassador_agreement`, {
    options
  })
}

export const generateCollaborationAgreement = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/collaboration_agreement`, {
    options
  })
}

export const generateNCNDAWebsiteAgreement = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/ncnda_website_agreement`, {
    options
  })
}

export const generateSalesMandate = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/sales_mandate_agreement`, {
    options
  })
}

export const generateCommissionAgreement = (options = {}) => {
  return axios.post(`${config.SERVER_URL}/contracts/commission_agreement`, {
    options
  })
}



// WEBPACK FOOTER //
// ./src/sources/ContractsSource.js